export enum FavoritesFilter {
  All = 'all',
  Videos = 'videos',
  Music = 'music',
  Articles = 'articles',
  Collections = 'collections',
}

export enum FavouriteType {
  Audio = 'audio',
  Track = 'track',
  Album = 'album',
  Playlist = 'playlist',
  Video = 'video',
  Article = 'article',
  Collection = 'collection',
  Podcast = 'podcast',
  Image = 'image',
}
